import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router";
import { BrowserTitles } from "../constants/BrowserTitles";
import { Menu, PageAreas } from "../constants/Constants";
import {
  PageTypes,
  ProductTypes
} from "../analytics/google/GoogleTagManagerConstants";
import { Paths } from "../constants/UrlConstants";
import Store from "./../content/Store";
import AppointmentDetails from "./claims/AppointmentDetails";
import ClaimsWrapper from "./claims/ClaimsWrapper";
import ClaimDetails from "./claims/details/ClaimDetails";
import PaymentDetails from "./claims/details/PaymentDetails";
import ContactUs from "./contactus/ContactUs";
import CoverDetails from "./cover/CoverDetails";
import CoverDocuments from "./cover/CoverDocuments";
import CoverWrapper from "./cover/CoverWrapper";
import MakeChangesToCover from "./cover/MakeChangesToCover";
import MembershipInfoSaga from "./cover/MembershipInfoSaga";
import Renewal from "./cover/Renewal";
import { Demo } from "./demo/Demo";
import HealthInformation from "./healthInformation/HealthInformation";
import HealthStore from "./healthStore/HealthStore";
import AskAMedicalExpert from "./healthsupport/AskAMedicalExpert";
import Check4Cancer from "./healthsupport/Check4Cancer";
import FastTrackAppointments from "./healthsupport/FastTrackAppointments";
import GPAppointments247 from "./healthsupport/gp247";
import HealthSupport from "./healthsupport/HealthSupport";
import WorkingBody from "./healthsupport/WorkingBody";
import Home from "./home/Home";
import Inbox from "./inbox/Inbox";
import InboxLoader from "./inbox/InboxLoader";
import GenericError from "./information/errors/GenericError";
import { Locked } from "./information/errors/Locked";
import { LockedPolicy } from "./information/errors/LockedPolicy";
import OnlineAccessUnavailable from "./information/errors/OnlineAccessUnavailable";
import { PageNotFound } from "./information/errors/PageNotFound";
import { RestrictedGroup } from "./information/errors/RestrictedGroup";
import { RestrictedPolicy } from "./information/errors/RestrictedPolicy";
import { RestrictedUser } from "./information/errors/RestrictedUser";
import SystemUnavailable from "./information/errors/SystemUnavailable";
import Timeout from "./information/errors/Timeout";
import InternalView from "./internalview/InternalView";
import MakeAClaim from "./makeAClaim/MakeAClaim";
import StartClaim from "./makeAClaim/StartClaim";
import MedicalConsent from "./medicalconsent/MedicalConsent";
import MedicalConsentConfirmation from "./medicalconsent/MedicalConsentConfirmation";
import MessageCentre from "./messageCentre/MessageCentre";
import AddAPlan from "./myprofile/AddAPlan";
import ChangeAddress from "./myprofile/ChangeAddress";
import ChangePhoneNumber from "./myprofile/ChangePhoneNumber";
import ChangeBankDetails from "./myprofile/ChangeBankDetails";
import MyProfile from "./myprofile/MyProfile";
import MyProfileContactPreferences from "./myprofile/MyProfileContactPreferences";
import MyProfileCommunicationNeeds from "./myprofile/MyProfileCommunicationNeeds";
import Permissions from "./myprofile/Permissions";
import Notifications from "./notifications/Notifications";
import ChooseYourPlan from "./polices/ChooseYourPlan";
import GDPR from "./polices/GDPR";
import CommunicationPreference from "./polices/CommunicationPreference";
import CommunicationSupportNeeds from "./myprofile/CommunicationSupportNeeds";
import ContactPreference from "./polices/ContactPreference";
import AuthCallBack from "./shared/AuthCallBack";
import Layout from "./shared/Layout";
import InternalViewMultipleSessions from "./internalview/InternalViewMultipleSessions";
import LoggedOut from "./logout/LoggedOut";
import LogoutCallback from "./logout/LogoutCallback";
import MemberDetails from "./onboarding/MemberDetails";
import IsUserLoggedIn from "./routeControllers/IsUserLoggedIn";
import DocumentPreference from "./preferences/DocumentPreference";
import ThriveInfoPage from "./shared/ThriveInfoPage";
import TimeSettings from "./information/errors/TimeSettings";
import AddAPlanFromNoAccess from "./myprofile/AddAPlanFromNoAccess";
import MovedToAxaHealth from "./information/errors/MovedToAxaHealth";
import { connect } from "react-redux";
import Check4CancerProstate from "./healthsupport/Check4CancerProstate";
import Check4CancerSkin from "./healthsupport/Check4CancerSkin";
import Check4CancerBreast from "./healthsupport/Check4CancerBreast";
import CancerDiagnosticServices from "./healthsupport/CancerDiagnosticServices";
import MFAErrorPage from "./information/MFAErrorPage";

const getPageNotFound = ({ history }) => (
  <Layout
    pageTitle={Store.ErrorPages.PageNotFound.PageTitle}
    browserTitle={BrowserTitles.PageNotFound}
    showCancelButton
    history={history}
    GDPRNotRequired
    PolicyNotRequired
  >
    <PageNotFound />
  </Layout>
);

export const Layouts = {
  HOL: "HOL",
  MOL: "MOL"
};
const mapStateToProps = (state) => {
  let policy =
  state && state.policyReducer && state.policyReducer.selectedPolicy;
  return {
    isHOL: state.layoutReducer && state.layoutReducer.layout === Layouts.HOL,
    isSaga: policy && policy.IsSaga,
    isLapsed : policy && policy.IsLapsed
  };
};

export class Routes extends Component {
  render() {
    return (
      <React.Fragment>
        <Switch>
        <Route
            path={Paths.HomeContactPreference}
            render={() => (
              <Layout
                pageTitle=""
                browserTitle={BrowserTitles.HomeContactPreference}
                showLogoutButton
                showHeaderMin
                showFooterMin
                history={this.props.history}
                GDPRNotRequired
                pageType={PageTypes.profile}
                onBoarding={Paths.HomeContactPreference}
              >
                <ContactPreference history={this.props.history} />
              </Layout>
            )}
          /> 
          <Route
            path={Paths.DocumentPreference}
            render={() => (
              <Layout
                browserTitle={BrowserTitles.DocumentPreference}
                GDPRNotRequired
                showFooterMin
                showHeaderMin
                showLogoutButton
                history={this.props.history}
                onBoarding={Paths.DocumentPreference}
              >
                <IsUserLoggedIn>
                  <DocumentPreference />
                </IsUserLoggedIn>
              </Layout>
            )}
          />
          <Route
            path={Paths.MemberDetails}
            render={() => (
              <Layout
                browserTitle={BrowserTitles.MemberDetails}
                GDPRNotRequired
                PolicyNotRequired
                showFooterMin
                showHeaderMin
                showLogoutButton
                history={this.props.history}
              >
                <IsUserLoggedIn>
                  <MemberDetails />
                </IsUserLoggedIn>
              </Layout>
            )}
          />

          <Route
            path={Paths.LoggedOut}
            render={(routeProps) => (
              <Layout
                browserTitle={BrowserTitles.LoggedOut}
                pageType={PageTypes.loggedout}
                GDPRNotRequired
                PolicyNotRequired
                showHeaderMin
                showFooterMin
              >
                <LoggedOut {...routeProps} />
              </Layout>
            )}
          />
          <Route
            path={Paths.LogoutCallback}
            render={(routeProps) => (
              <Layout
                browserTitle={BrowserTitles.LogoutRedirect}
                pageType={PageTypes.logoutredirect}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
                showHeaderMin
                showFooterMin
              >
                <LogoutCallback {...routeProps} />
              </Layout>
            )}
          />
          <Route
            path={"/AuthCallback"}
            render={(routeProps) => (
              <Layout
                pageTitle="Login"
                browserTitle={BrowserTitles.Login}
                pageType={PageTypes.login}
                history={this.props.history}
                showHeaderMin
                showFooterMin
                GDPRNotRequired
                PolicyNotRequired
              >
                <AuthCallBack {...routeProps} history={this.props.history} />
              </Layout>
            )}
          />

          <Route
            exact
            path={Paths.HomeRoot}
            render={() => (
              <Layout
                pageTitle=""
                selectedMenu={Menu.Home}
                browserTitle={BrowserTitles.Home}
                pageType={PageTypes.homepage}
                history={this.props.history}
                checkVersion
              >
                <Home />
              </Layout>
            )}
          />

          <Route
            path={Paths.Demo}
            render={() => (
              <Layout
                pageTitle={"demo"}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <Demo />
              </Layout>
            )}
          />
          <Route
            path={Paths.HealthStore}
            render={() => (
              <Layout
                pageTitle= "health store"
                selectedMenu={Menu.HealthStore}
                browserTitle={this.props.isHOL ? BrowserTitles.CustomerOffers : BrowserTitles.MemberOffers}
                pageType={PageTypes.healthsupport}
                pageProduct={ProductTypes.activeplus}
                history={this.props.history}
                checkVersion
              >
                <HealthStore />
              </Layout>
            )}
          />
          <Route
            path={Paths.GPAppointments247}
            render={() => (
              <Layout
                pageTitle=" A fast, easy way to see a GP"
                selectedMenu={Menu.HealthSupport}
                browserTitle={BrowserTitles.GPAppointments247}
                pageType={PageTypes.healthsupport}
                history={this.props.history}
                GDPRNotRequired
                checkVersion
              >
                <GPAppointments247 />
              </Layout>
            )}
          />
          <Route
          exact
            path={Paths.Check4Cancer}
            render={() => (
              <Layout
                pageTitle="Cancer diagnostic services"
                selectedMenu={Menu.HealthSupport}
                browserTitle={this.props.isHOL ? BrowserTitles.Check4Cancer : BrowserTitles.CancerDiagnosticServices}
                pageType={PageTypes.healthsupport}
                history={this.props.history}
                GDPRNotRequired
                checkVersion
              >
               {this.props.isHOL ? <Redirect to={Paths.NotFound} />: this.props.isSaga? <Check4Cancer /> : <CancerDiagnosticServices/>}
              </Layout>
            )}
          />
          <Route
          exact
            path={Paths.Check4CancerProstate}
            render={() => (
              <Layout
                pageTitle="Learn more about prostate cancer diagnosis service"
                selectedMenu={Menu.HealthSupport}
                browserTitle={BrowserTitles.Check4CancerProstate}
                pageType={PageTypes.healthsupport}
                history={this.props.history}
                GDPRNotRequired
                checkVersion
              >
              {/* {this.props.isHOL ? <Redirect to={Paths.NotFound} /> : <Check4CancerProstate /> } */}
              <Check4CancerProstate /> 
              </Layout>
            )}
          />
          <Route
          exact
            path={Paths.Check4CancerSkin}
            render={() => (
              <Layout
                pageTitle="Learn more about prostate cancer diagnosis service"
                selectedMenu={Menu.HealthSupport}
                browserTitle={BrowserTitles.Check4CancerSkin}
                pageType={PageTypes.healthsupport}
                history={this.props.history}
                GDPRNotRequired
                checkVersion
              >
                {this.props.isHOL ? <Redirect to={Paths.NotFound} /> : <Check4CancerSkin />}
              </Layout>
            )}
          />
          <Route
          exact
            path={Paths.Check4CancerBreast}
            render={() => (
              <Layout
                pageTitle="Breast diagnostic service"
                selectedMenu={Menu.HealthSupport}
                browserTitle={BrowserTitles.Check4CancerBreast}
                pageType={PageTypes.healthsupport}
                history={this.props.history}
                GDPRNotRequired
                checkVersion
              >
                {this.props.isHOL ? <Redirect to={Paths.NotFound} /> : <Check4CancerBreast />}
              </Layout>
            )}
          />
          <Route
            path={this.props.isHOL ? Paths.HealthHub : Paths.HealthSupport}
            render={() => (
              <Layout
                pageTitle="Health Support"
                selectedMenu={Menu.HealthSupport}
                browserTitle={this.props.isHOL ? BrowserTitles.HealthSupportHub : BrowserTitles.HealthSupport}
                pageType={PageTypes.healthsupport}
                productType={ProductTypes.asktheexpert}
                history={this.props.history}
                GDPRNotRequired
                checkVersion
              >
                <HealthSupport />
              </Layout>
            )}
          />
          {window?.axa?.features?.healthUnlockedFeature && (
            <Route
              path={Paths.HealthInformation}
              render={() => (
                <Layout
                  selectedMenu={Menu.HealthSupport}
                  pageTitle={"Health Information"}
                  browserTitle={BrowserTitles.HealthInfo}
                  pageType={PageTypes.healthsupport}
                  productType={ProductTypes.asktheexpert}
                  history={this.props.history}
                  checkVersion
                >
                  <HealthInformation />
                </Layout>
              )}
            />
          )}
          <Route
            path={Paths.ChooseYourPlan}
            render={() => (
              <Layout
                browserTitle={BrowserTitles.ChooseYourPlan}
                pageType={PageTypes.login}
                pageProduct={ProductTypes.healthinsurance}
                history={this.props.history}
                showLogoutButton
                showHeaderMin
                showFooterMin
                GDPRNotRequired
                selectedPolicyNotRequired
                checkVersion
              >
                <ChooseYourPlan history={this.props.history} />
              </Layout>
            )}
          />

          <Route
            path={Paths.Timeout}
            render={() => (
              <Layout
                // pageTitle={Store.ErrorPages.Timeout.PageTitle}
                pageTitle={this.props.isHOL ? Store.ErrorPages.Timeout.PageTitle : null}
                browserTitle={BrowserTitles.Timeout}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <Timeout />
              </Layout>
            )}
          />
          <Route
            path={Paths.NotFound}
            render={() => getPageNotFound(this.props)}
          />
          <Route
            path={Paths.Locked}
            render={() => (
              <Layout
                pageTitle={Store.ErrorPages.Locked.PageTitle}
                browserTitle={BrowserTitles.Locked}
                pageType={PageTypes.login}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <Locked />
              </Layout>
            )}
          />
          <Route
            path={Paths.TimeSetting}
            render={() => (
              <Layout
                pageTitle={Store.ErrorPages.TimeSettings.PageTitle}
                browserTitle={BrowserTitles.TimeSettings}
                pageType={PageTypes.login}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <TimeSettings />
              </Layout>
            )}
          />
          <Route
            path={Paths.OnlineAccessUnavailable}
            render={() => (
              <Layout
                // pageTitle={Store.ErrorPages.OnlineAccessUnavailable.PageTitle}
                
                pageTitle={this.props.isHOL ? Store.ErrorPages.OnlineAccessUnavailable.PageTitle : null}
                browserTitle={BrowserTitles.OnlineAccessUnavailable}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <OnlineAccessUnavailable />
              </Layout>
            )}
          />
          <Route
            path={Paths.MovedToAxaHealth}
            render={() => (
              <Layout
                pageTitle={Store.MovedToAxaHealth.pageTitle}
                browserTitle={Store.MovedToAxaHealth.browserTitle}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <MovedToAxaHealth />
              </Layout>
            )}
          />
          <Route
            path={Paths.PolicyLocked}
            render={() => (
              <Layout
                pageTitle={Store.ErrorPages.LockedPolicy.PageTitle}
                browserTitle={BrowserTitles.PolicyLocked}
                pageType={PageTypes.login}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <LockedPolicy />
              </Layout>
            )}
          />

          <Route
            path={Paths.RestrictedPolicy}
            render={() => (
              <Layout
                pageTitle={Store.ErrorPages.RestrictedPolicy.PageTitle}
                browserTitle={BrowserTitles.RestrictedPolicy}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <RestrictedPolicy />
              </Layout>
            )}
          />
          <Route
            path={Paths.RestrictedGroup}
            render={() => (
              <Layout
                pageTitle={Store.ErrorPages.RestrictedGroup.PageTitle}
                browserTitle={BrowserTitles.RestrictedGroup}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <RestrictedGroup />
              </Layout>
            )}
          />
          <Route
            path={Paths.RestrictedUser}
            render={() => (
              <Layout
                pageTitle={Store.ErrorPages.RestrictedUser.PageTitle}
                browserTitle={BrowserTitles.RestrictedUser}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <RestrictedUser />
              </Layout>
            )}
          />

          <Route
            path={Paths.Error}
            render={() => (
              <Layout
                // pageTitle={Store.ErrorPages.GenericError.PageTitle}
                pageTitle={this.props.isHOL ? Store.ErrorPages.GenericError.PageTitle : null}
                browserTitle={BrowserTitles.GenericError}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <GenericError />
              </Layout>
            )}
          />

          <Route
          path={Paths.MFAIncorrectAttemptErrorPage}
          render={() => (
              <Layout
                // pageTitle={Store.ErrorPages.GenericError.PageTitle}
                // pageTitle={this.props.isHOL ? Store.ErrorPages.GenericError.PageTitle : null}
                browserTitle={BrowserTitles.GenericError}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <MFAErrorPage />
              </Layout>
            )}
          />

          <Route
            path={Paths.Cover}
            render={() => (
              <Layout
                selectedMenu={Menu.Cover}
                browserTitle={BrowserTitles.Cover}
                history={this.props.history}
                pageArea={PageAreas.FaqAreaCoverPage}
                pageType={PageTypes.cover}
                pageProduct={ProductTypes.healthinsurance}
                checkVersion
              >
                <CoverWrapper>
                  <CoverDetails />
                </CoverWrapper>
              </Layout>
            )}
          />
          <Route
            path={Paths.MakeChangesToCover}
            render={() => (
              <Layout
                selectedMenu={Menu.Cover}
                history={this.props.history}
                browserTitle={BrowserTitles.MakeChangesToCover}
                pageArea={PageAreas.FaqAreaCoverPage}
                pageType={PageTypes.cover}
                pageProduct={ProductTypes.healthinsurance}
                checkVersion
              >
                <CoverWrapper>
                  <MakeChangesToCover />
                </CoverWrapper>
              </Layout>
            )}
          />
          <Route
            path={Paths.MembershipInfoSaga}
            render={() => (
              <Layout
                selectedMenu={Menu.Cover}
                history={this.props.history}
                browserTitle={BrowserTitles.MembershipInfo}
                pageArea={PageAreas.FaqAreaCoverPage}
                pageType={PageTypes.cover}
                checkVersion
              >
                <CoverWrapper>
                  <MembershipInfoSaga />
                </CoverWrapper>
              </Layout>
            )}
          />
          <Route
            path={Paths.Renewal}
            render={() => (
              <Layout
                selectedMenu={Menu.Cover}
                history={this.props.history}
                browserTitle={BrowserTitles.Renewal}
                pageArea={PageAreas.FaqAreaCoverPage}
                pageType={PageTypes.cover}
                checkVersion
              >
                <CoverWrapper>
                  <Renewal />
                </CoverWrapper>
              </Layout>
            )}
          />
          {(this.props.shouldShowClaims || this.props.shouldShowHowToClaim) && (
            <Route
              path={Paths.Claims}
              render={(routeProps) => (
                <Layout
                  selectedMenu={Menu.Claims}
                  history={this.props.history}
                  browserTitle={BrowserTitles.Claims}
                  GDPRNotRequired
                  pageType={PageTypes.claims}
                  pageProduct={ProductTypes.healthinsurance}
                  checkVersion
                >
                  <ClaimsWrapper {...{ ...routeProps, selectedTabIndex: 0 }} />
                </Layout>
              )}
            />
          )}
          {this.props.shouldShowClaims &&
            !this.props.shouldOnlyShowHowToClaims && (
              <Route
                path={Paths.MakeAClaim}
                render={(routeProps) => (
                  <Layout
                    selectedMenu={Menu.Claims}
                    history={this.props.history}
                    browserTitle={BrowserTitles.MakeAClaim}
                    GDPRNotRequired
                    pageType={PageTypes.makeaclaim}
                    pageProduct={ProductTypes.healthinsurance}
                    pageTitle={Store.MakeAClaim.pageTitle}
                    showCancelButton
                    cancelButtonText="Close"
                    showHeaderMin
                  >
                    <MakeAClaim {...routeProps} />
                  </Layout>
                )}
              />
            )}
          {this.props.shouldOnlyShowHowToClaims && (
            <Redirect path={Paths.MakeAClaim} to={Paths.HowToClaim} />
          )}
          {this.props.shouldShowClaims && (
            <Route
              path={Paths.StartClaim}
              render={(routeProps) => (
                <Layout
                  history={this.props.history}
                  browserTitle={BrowserTitles.MakeAClaim}
                  GDPRNotRequired
                  pageType={PageTypes.makeaclaim}
                  pageProduct={ProductTypes.healthinsurance}
                  pageTitle={Store.MakeAClaim.pageTitle}
                  showCancelButton
                  cancelButtonText="Close"
                  showHeaderMin
                >
                  <StartClaim {...routeProps} />
                </Layout>
              )}
            />
          )}
          {this.props.shouldShowClaims && this.props.shouldShowHowToClaim && (
            <Route
              path={Paths.HowToClaim}
              render={(routeProps) => (
                <Layout
                  selectedMenu={Menu.Claims}
                  history={this.props.history}
                  browserTitle={BrowserTitles.HowToClaim}
                  GDPRNotRequired
                  pageType={PageTypes.makeaclaim}
                  pageProduct={ProductTypes.healthinsurance}
                  checkVersion
                >
                  <ClaimsWrapper {...{ ...routeProps, selectedTabIndex: 2 }} />
                </Layout>
              )}
            />
          )}
          {this.props.shouldShowClaims && (
            <Route
              path={Paths.ClaimDetails}
              render={(routeProps) => (
                <Layout
                  selectedMenu={Menu.Claims}
                  history={this.props.history}
                  browserTitle={BrowserTitles.ClaimDetails}
                  GDPRNotRequired
                  pageType={PageTypes.claims}
                  pageProduct={ProductTypes.healthinsurance}
                  checkVersion
                >
                  <ClaimDetails {...routeProps} />
                </Layout>
              )}
            />
          )}
          {this.props.shouldShowClaims && (
            <Route
              path={Paths.PaymentDetails}
              render={(routeProps) => (
                <Layout
                  selectedMenu={Menu.Claims}
                  history={this.props.history}
                  browserTitle={BrowserTitles.PaymentDetails}
                  GDPRNotRequired
                  pageType={PageTypes.paymentdetails}
                  checkVersion
                >
                  <PaymentDetails {...routeProps} />
                </Layout>
              )}
            />
          )}
          {this.props.shouldShowClaims && (
            <Route
              path={Paths.MedicalConsent}
              render={(routeProps) => (
                <Layout
                  pageTitle={
                    Store.MedicalConsent.MedicalConsentClaimInput.PageTitle
                  }
                  browserTitle={BrowserTitles.MedicalConsent}
                  pageType={PageTypes.profile}
                  history={this.props.history}
                  showCancelButton
                  showHeaderMin
                >
                  <MedicalConsent {...routeProps} />
                </Layout>
              )}
            />
          )}
          {this.props.shouldShowClaims && (
            <Route
              path={Paths.MedicalConsentConfirmation}
              render={() => (
                <Layout
                  pageTitle={
                    Store.MedicalConsent.MedicalConsentConfirmation.PageTitle
                  }
                  browserTitle={BrowserTitles.MedicalConsent}
                  history={this.props.history}
                  showCancelButton
                  showHeaderMin
                >
                  <MedicalConsentConfirmation />
                </Layout>
              )}
            />
          )}
          {this.props.shouldShowClaims && (
            <Route
              path={Paths.Appointments}
              render={(routeProps) => (
                <Layout
                  selectedMenu={Menu.Claims}
                  pageTitle="Specialist Appointment Booking Service"
                  browserTitle={BrowserTitles.FastTrack}
                  pageType={PageTypes.claims}
                  history={this.props.history}
                  checkVersion
                >
                  <ClaimsWrapper {...routeProps} selectedTabIndex={4} />
                </Layout>
              )}
            />
          )}
          {this.props.shouldShowClaims && (
            <Route
              path={Paths.AppointmentDetail}
              render={(routeProps) => (
                <Layout
                  selectedMenu={Menu.Claims}
                  pageTitle="Appointment details"
                  browserTitle={BrowserTitles.FastTrackAppointmentDetails}
                  pageType={PageTypes.claims}
                  history={this.props.history}
                  checkVersion
                >
                  <AppointmentDetails {...routeProps} />
                </Layout>
              )}
            />
          )}

          <Route
            path={Paths.PersonConsent}
            render={() => (
              <Layout
                pageTitle=""
                browserTitle={BrowserTitles.PersonConsent}
                showLogoutButton
                showHeaderMin
                showFooterMin
                history={this.props.history}
                GDPRNotRequired
                pageType={PageTypes.profile}
                onBoarding={Paths.PersonConsent}
              >
                <GDPR history={this.props.history} />
              </Layout>
            )}
          />
          <Route
            path={Paths.HomeCommunicationPreference}
            render={() => (
              <Layout
                pageTitle=""
                browserTitle={BrowserTitles.HomeCommunicationPreference}
                showLogoutButton
                showHeaderMin
                showFooterMin
                history={this.props.history}
                GDPRNotRequired
                pageType={PageTypes.profile}
                onBoarding={Paths.HomeCommunicationPreference}
              >
                <CommunicationPreference history={this.props.history} />
              </Layout>
            )}
          />
          <Route
          path={Paths.HomeCommunicationSupportNeeds}
            render={() => (
              <Layout
                pageTitle=""
                browserTitle={BrowserTitles.HomeCommunicationSupportNeeds}
                showLogoutButton
                showHeaderMin
                showFooterMin
                history={this.props.history}
                GDPRNotRequired
                pageType={PageTypes.profile}
                onBoarding={Paths.HomeCommunicationSupportNeeds}
              >
                <CommunicationSupportNeeds history={this.props.history} />
              </Layout>
            )}
          />
          <Route
            path={Paths.MyProfile}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.MyProfile}
                pageTitle=""
                GDPRNotRequired
                pageArea={PageAreas.FaqAreaMyPersonalDetailsPage}
                pageType={PageTypes.profile}
              >
                <MyProfile history={this.props.history} />
              </Layout>
            )}
          />
          <Route
            path={Paths.MyProfileContactPreferences}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.MyProfileContactPreferences}
                pageTitle=""
                GDPRNotRequired
                pageArea={PageAreas.FaqAreaMyPersonalDetailsPage}
                pageType={PageTypes.profile}
              >
                <MyProfileContactPreferences history={this.props.history} />
              </Layout>
            )}
          />
          <Route
            path={Paths.CommunicationPreference}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.CommunicationPreference}
                pageTitle=""
                GDPRNotRequired
                pageArea={PageAreas.FaqAreaMyPersonalDetailsPage}
                pageType={PageTypes.profile}
              >
                <MyProfileCommunicationNeeds history={this.props.history} />
              </Layout>
            )}
          />
          <Route
            path={Paths.Permissions}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.Permissions}
                pageTitle=""
                GDPRNotRequired
                pageArea={PageAreas.FaqAreaMyPersonalDetailsPage}
                pageType={PageTypes.profile}
                checkVersion
              >
                <Permissions history={this.props.history} />
              </Layout>
            )}
          />
          <Route
            path={Paths.ChangePhoneNumber}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.ChangePhoneNumber}
                GDPRNotRequired
                pageArea={PageAreas.FaqAreaMyPersonalDetailsPage}
                pageType={PageTypes.profile}
              >
                <ChangePhoneNumber />
              </Layout>
            )}
          />
          <Route
            path={Paths.ChangeAddress}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.ChangeAddress}
                GDPRNotRequired
                pageArea={PageAreas.FaqAreaMyPersonalDetailsPage}
                pageType={PageTypes.profile}
              >
                <ChangeAddress />
              </Layout>
            )}
          />
          <Route
            path={Paths.ChangeBankDetails}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.ChangeBankDetails}
                GDPRNotRequired
                pageArea={PageAreas.FaqAreaMyPersonalDetailsPage}
                pageType={PageTypes.profile}
              >
                <ChangeBankDetails/>
              </Layout>
            )}
          />
          <Route
            path={Paths.AddAPlan}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.AddAPlan}
                pageArea={PageAreas.FaqAreaMyPersonalDetailsPage}
                pageType={PageTypes.profile}
                pageProduct={ProductTypes.healthinsurance}
              >
                <AddAPlan />
              </Layout>
            )}
          />

          <Route
            path={Paths.AddAPlanFromNoAccess}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.AddAPlan}
                PolicyNotRequired
                showFooterMin
                showHeaderMin
                showLogoutButton
                GDPRNotRequired
              >
                <AddAPlanFromNoAccess />
              </Layout>
            )}
          />

          <Route
            path={Paths.CoverDocuments}
            render={() => (
              <Layout
                selectedMenu={Menu.Cover}
                history={this.props.history}
                browserTitle={BrowserTitles.CoverDocuments}
                pageType={PageTypes.cover}
                pageProduct={ProductTypes.healthinsurance}
                checkVersion
              >
                <CoverWrapper>
                  <CoverDocuments />
                </CoverWrapper>
              </Layout>
            )}
          />
          {!this.props.isLapsed && (<Route
            path={Paths.WorkingBody}
            render={() => (
              <Layout
                selectedMenu={Menu.HealthSupport}
                history={this.props.history}
                browserTitle={BrowserTitles.WorkingBody}
                pageType={PageTypes.healthsupport}
                pageProduct={ProductTypes.healthinsurance}
                checkVersion
              >
                <WorkingBody />
              </Layout>
            )}
          />)}
          <Route
            path={Paths.AskAMedicalExpert}
            render={() => (
              <Layout
                selectedMenu={Menu.HealthSupport}
                history={this.props.history}
                browserTitle={BrowserTitles.AskAMedicalExpert}
                pageType={PageTypes.healthsupport}
                pageProduct={ProductTypes.asktheexpert}
                checkVersion
              >
                <AskAMedicalExpert />
              </Layout>
            )}
          />
          {this.props.shouldShowFastTrack ? (
            <Route
              path={Paths.FastTrack}
              render={() => (
                <Layout
                  selectedMenu={Menu.HealthSupport}
                  history={this.props.history}
                  browserTitle={BrowserTitles.FastTrack}
                  pageType={PageTypes.healthsupport}
                  pageProduct={ProductTypes.healthinsurance}
                  checkVersion
                >
                  <FastTrackAppointments />
                </Layout>
              )}
            />
          ) : null}
          <Route
            path={Paths.ContactUs}
            render={() => (
              <Layout
                selectedMenu={Menu.ContactUs}
                history={this.props.history}
                browserTitle={BrowserTitles.ContactUs}
                pageType={PageTypes.contactus}
                checkVersion
              >
                <ContactUs />
              </Layout>
            )}
          />
          <Route
            path={Paths.Inbox}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.Inbox}
                pageType={PageTypes.inbox}
              >
                <Inbox />
              </Layout>
            )}
          />
          <Route
            path={Paths.MessageCentre}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.Inbox}
                pageType={PageTypes.inbox}
              >
                <MessageCentre />
              </Layout>
            )}
          />
          <Route
            path={Paths.Notifications}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.Notifications}
                pageType={PageTypes.notifications}
                checkVersion
              >
                <Notifications />
              </Layout>
            )}
          />
          <Route
            path={Paths.InboxLoader}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.Inbox}
              >
                <InboxLoader />
              </Layout>
            )}
          />
          <Route
            path={Paths.Thrive}
            render={() => (
              <Layout history={this.props.history} showFooterMin showHeaderMin>
                <ThriveInfoPage />
              </Layout>
            )}
          />

          <Route
            path={Paths.InternalView}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.InternalView}
                PolicyNotRequired
              >
                <InternalView />
              </Layout>
            )}
          />
          <Route
            path={Paths.InternalViewSessionExists}
            render={() => (
              <Layout
                history={this.props.history}
                browserTitle={BrowserTitles.InternalView}
                PolicyNotRequired
              >
                <InternalViewMultipleSessions />
              </Layout>
            )}
          />

          <Redirect exact path="/Login" to={Paths.HomeRoot} />
          <Redirect exact path="/Account/Login" to={Paths.HomeRoot} />
          <Route
            exact
            path="/Account/Login/:token"
            render={({ match }) => <Redirect to={Paths.HomeRoot} />}
          />
          <Redirect exact path="/activateAccount" to={Paths.HomeRoot} />
          <Route
            exact
            path="/activateAccount/:token"
            render={({ match }) => <Redirect to={Paths.HomeRoot} />}
          />
          <Redirect
            exact
            path="/Account/RegisterPolicyDetails"
            to={Paths.HomeRoot}
          />
          <Redirect exact path="/register" to={Paths.HomeRoot} />
          <Redirect exact path="/registerlogin" to={Paths.HomeRoot} />
          <Redirect exact path="/registerconfirm" to={Paths.HomeRoot} />
          <Redirect exact path="/registrationNextSteps" to={Paths.HomeRoot} />

          <Redirect exact path="/forgottenemail" to={Paths.HomeRoot} />
          <Redirect exact path="/forgottenpassword" to={Paths.HomeRoot} />
          <Redirect
            exact
            path="/incompleteforgottenpassword"
            to={Paths.HomeRoot}
          />
          <Redirect exact path="/forgottenpasswordnext" to={Paths.HomeRoot} />
          <Redirect
            exact
            path="/forgottenpasswordlinkexpired"
            to={Paths.HomeRoot}
          />
          <Redirect
            exact
            path="/VerifyForgottenPassword/:token"
            to={Paths.HomeRoot}
          />
          <Redirect
            exact
            path="/forgottenPasswordConfirmation"
            to={Paths.HomeRoot}
          />

          <Route
            path={Paths.SystemUnavailable}
            render={() => (
              <Layout
                pageTitle={Store.ErrorPages.SystemUnavailable.PageTitle}
                browserTitle={BrowserTitles.SystemUnavailable}
                history={this.props.history}
                GDPRNotRequired
                PolicyNotRequired
              >
                <SystemUnavailable />
              </Layout>
            )}
          />
          
          <Route render={() => getPageNotFound(this.props)} />
        </Switch>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(Routes);
